/**
 * 新增 编辑
 * @author 3173
 * @description 个人证书管理 新增/编辑
 * @Date  2020/9/18
 */
import React, { Component } from 'react';
import { Form } from 'antd'
import { component_tool, framework_tool } from '@/tool'
import { WizTableForm, WizClassifySelectRe, WizAuthority } from '../../../common'
import moment from 'moment';

let { WizAvatarUpload, ossFileUtils } = framework_tool

let {
  WizButton,
  WizSelect,
  WizTooltip,
  WizInput,
  WizIcon,
  WizUpload,
  WizDatePicker,
  WizRow,
  WizCol,
  WizCard,
  WizRadio,
  WizDivider,
  WizCheckbox,
  WizInputNumber,
  Wizmessage,
  WizAlert
} = component_tool;
let WizForm = Form
let Item = Form.Item
let Option = WizSelect.Option

/**
 * 此组件没有继承WizComponent，因为需要使用Form.create()该组件
 * 继承WizComponent后 form的部分功能缺失了
 * 初步怀疑是WizComponent修改了生命周期的钩子导致的
 * by mll 2020-2-4
 */

class PersonalCertForm extends Component {

  constructor(props) {
    super(props);
    let { initialValue } = props;

    if (initialValue.certDate) {
      initialValue.certDate = moment(initialValue.certDate)
    }
    if (initialValue.certDetail && initialValue.certDetail.endDate) {
      initialValue.endDate = moment(initialValue.certDetail.endDate)
    }
    if (initialValue.certDetail && initialValue.certDetail.startDate) {
      initialValue.startDate = moment(initialValue.certDetail.startDate)
    }
    if (initialValue.certDetail && initialValue.certDetail.reCheckDate) {
      initialValue.reCheckDate = moment(initialValue.certDetail.reCheckDate)
    }
    if (initialValue.certDetail && initialValue.certDetail.firstDate) {
      initialValue.firstDate = moment(initialValue.certDetail.firstDate)
    }
    //证书默认展示信息
    if (initialValue.certId && initialValue.certName) {
      initialValue.certInfo = [{ id: initialValue.certId, name: initialValue.certName }];
    }
    //学员默认展示信息
    if (initialValue.personId && initialValue.fullName) {
      initialValue.personInfo = [{ personId: initialValue.personId, fullName: initialValue.fullName, id: initialValue.personId }];
    }



    this.state = {
      certKey: "certKey",//证书表单key
      type: initialValue && initialValue.certType ? initialValue.certType : undefined,
      certId: initialValue && initialValue.certId ? initialValue.certId : undefined,
      personId: initialValue && initialValue.personId ? initialValue.personId : undefined,
      mobile: initialValue && initialValue.mobile ? initialValue.mobile : undefined,
      idCard: initialValue && initialValue.idCard ? initialValue.idCard : undefined,
      userName: initialValue && initialValue.userName ? initialValue.userName : undefined,
      userType: initialValue && initialValue.userType ? initialValue.userType : undefined,
      personState: initialValue && initialValue.userState ? initialValue.userState : undefined,
    }
    this.initialValue = props.initialValue ? props.initialValue : {},
      this.clearWizCallBack = [];
  }

  /** ?提示 */
  _renderCheckTips(tips) {
    if (tips) {
      return (
        <WizTooltip title={tips} >
          <WizIcon type='question-circle-o' />
        </WizTooltip>
      )
    }
  }

  /**证书名称 */
  renderCertName(value, valueRows) {
    return (
      <div> {valueRows && valueRows[0] && valueRows[0].name ? valueRows[0].name : ''}</div>
    )
  }
  /**人名称 */
  renderPersonName(value, valueRows) {
    return (
      <div> {valueRows && valueRows[0] && valueRows[0].fullName ? valueRows[0].fullName : ''}</div>
    )
  }

  certColumns() {
    return [
      {
        name: "id",
        formItem: {
          type: "hidden"
        }
      },
      {
        title: "证书名称",
        name: "name",
        tableItem: {width: 300},
        searchItem: {}
      },
      {
        title: "证书类型",
        name: "classify",
        tableItem: {width: 80},
        dict: [
          { code: 1, codeName: "个人" },
          { code: 2, codeName: "店端" }
        ]
      },
      {
        title: "证书类别",
        name: "type",
        tableItem: {width: 80},
        dict: [
          { code: 1, codeName: "培训" },
          { code: 2, codeName: "社会" }
        ]
      },
      {
        title: "状态",
        name: "state",
        dataIndex: "state",
        tableItem: {width: 80},
        dict: [
          { code: 1, codeName: "有效" },
          { code: 0, codeName: "无效" }
        ]
      },

    ]
  }

  userColumns () {
    return [
        {
            title: '账号',
            name: 'userName',
            dataIndex: 'userName',
            searchItem: {},
            tableItem: {width: 120}
        },
        {
            title: '姓名',
            name: 'fullName',
            dataIndex: 'fullName',
            searchItem: {},
            tableItem: {width: 120}
        },
        {
            title: '身份证号/工号',
            name: 'idCard',
            dataIndex: 'idCard',
           // searchItem: {},
            tableItem: {width: 200}
        },
        {
            title: '手机号',
            name: 'mobile',
            dataIndex: 'mobile',
            tableItem: {width: 120}
        },
        {
            title: '状态',
            name: 'state',
            dataIndex: 'state',
            dict: [
                { code: 1, codeName: '激活' },
                { code: 0, codeName: '禁用' },
            ],
            searchItem: {
                type: 'select',
                width: 171
            },
            tableItem: {width: 100}
        }
    ]
}

  /**获取证书信息 */
  getCertInfo(values, e) {
    let row = values.valueRows;
    if (row && row[0]) {
      let data = row[0]
      this.setState({
        certId: data.id,
        personId: undefined
      })
    }
  }

  /** 获取学员信息 */
  getPersonInfo(values, e) {
    let row = values.valueRows;
    if (row && row[0]) {
      let data = row[0]
      this.setState({
        mobile: data.mobile,
        idCard: data.idCard,
        personId: data.personId,
        userName: data.userName,
        personState: data.state
      })
    }
  }

  /**清除学员信息 */
  clearOnChange(nextTargetValues) {
    if (!nextTargetValues) {
      this.setState({
        personId: undefined,
        certId: undefined
      })
    }
  }

  /**
   * 表单基础内容
   *  Item hasFeedback 展示校验状态图标
   */
  _base() {
    const { getFieldDecorator } = this.props.form;
    const { type, certId, personId} = this.state;

    let items = [
      <Item label="证书类别" >
        {getFieldDecorator('type', {
          initialValue: this.initialValue.certType,
          rules: [{ required: true, message: '请选择证书类别' }],
        })(
          <WizSelect
            disabled={this.initialValue.certType}
            placeholder="请选择证书类别"
            onChange={(value, option) => {
              this.setState({ type: value, certKey: "certKey" + value, certId: undefined, personId: undefined })
            }}>
            <Option value={1}>培训</Option>
            <Option value={2}>社会</Option>
          </WizSelect>
        )}
      </Item>
    ]
    if (type) {
      items.push(
        <Item label="选择证书" required layout="inline">
          {getFieldDecorator('certId', {
            rules: [{ required: true, message: '请选择证书', }],
            initialValue: this.initialValue.certId
          })(<WizTableForm key={this.state.certKey} onClearWiz={this._onClearWiz2.bind(this)} rowkey='id' rowName='name' tableApi={{
            path: 'cert/getListByPage',
            apiParams: {
              type: type,
              classify: 1, //只获取个人的
              state: 1  //只取有效的
            }
          }}
            renderValue={this.initialValue && this.initialValue.certId ? this.renderCertName.bind(this) : undefined}
            onChange={this.clearOnChange.bind(this)}
            columns={this.certColumns()} title={'选择证书'} selectType={'radio'}
            initRows={this.initialValue.certInfo}
            onSubmit={this.getCertInfo.bind(this)} />)}
        </Item>
      )
    }
    if (certId) {
      //const studentUserConfig = WizTableForm.Config.user(this, { apiParams: {} });
      items.push(<Item label="选择学员" required layout="inline" style={{ marginBottom: 0 }}>
        {getFieldDecorator('personId', {
          rules: [{ required: true, message: '请选择学员', }],
          initialValue: this.initialValue.personId
        })(<WizTableForm key={'student' + this.state.type} onClearWiz={this._onClearWiz3.bind(this)}
          rowKey='personId' rowName='fullName' rowTitle='userName'
          tableApi={{
            path: 'cert/queryPersonInfo',
            apiParams: {
              id: certId
            }
          }}
          columns={this.userColumns()}
          renderValue={this.initialValue && this.initialValue.personId ? this.renderPersonName.bind(this) : undefined}
          title={'选择学员'} selectType={'radio'}
          initRows={this.initialValue.personInfo ? this.initialValue.personInfo : undefined}
          onSubmit={this.getPersonInfo.bind(this)}/>)}
      </Item>)
    }
    //学员信息部分
    if (personId) {
      items.push(<Item label="账号" layout="inline" style={{ marginBottom: 0, width: '100%' }}>
        <Item colon={false} style={{ marginBottom: 0, display: 'inline-block', width: '30%' }}>{this.state.userName}</Item>
        <Item label={this.getIdCardStr(this.state.userType)} style={{ marginBottom: 0, display: 'inline-block', marginLeft: '15%', width: '55%', }}
          wrapperCol={{
            xs: { span: 18, offset: 0 },
            sm: { span: 18, offset: 0 },
          }}
          labelCol={{
            xs: { span: 6, offset: 0 },
            sm: { span: 6, offset: 0 },
          }}>
          {this.state.idCard}
        </Item>
      </Item>)
      items.push(<Item label="手机号" layout="inline" style={{ width: '100%' }}>
        <Item colon={false} style={{ marginBottom: 0, display: 'inline-block', width: '30%' }}>{this.state.mobile}</Item>
        <Item label="账号状态" style={{ marginBottom: 0, display: 'inline-block', marginLeft: '15%', width: '55%', }}
          wrapperCol={{
            xs: { span: 18, offset: 0 },
            sm: { span: 18, offset: 0 },
          }}
          labelCol={{
            xs: { span: 6, offset: 0 },
            sm: { span: 6, offset: 0 },
          }}>
          {this.state.personState === 1 ? "激活" : "禁用"}
        </Item>
      </Item>)
    }
    return items
  }

  getIdCardStr = (userType) => {
    if (userType === undefined) {
      return '身份证/工号'
    } else if (userType === 1 || userType === 2 || userType === 5) {
      return '工号'
    }
    return '身份证'
  }


  _baseEnd() {
    const { getFieldDecorator } = this.props.form;
    const { type, certId, personId } = this.state;
    if (type && personId) {
      return <Item label="状态" >
        {getFieldDecorator('state', {
          initialValue: this.initialValue.state || this.initialValue.state == 0 ? this.initialValue.state : 1
        })(
          <WizRadio.Group>
            <WizRadio value={1}>有效</WizRadio>
            <WizRadio value={0}>无效 </WizRadio>
          </WizRadio.Group>
        )}
      </Item>
    }
  }


  /**
    * 拓展属性
    */
  _ext = () => {
    const { getFieldDecorator } = this.props.form;
    const { type, certId, personId } = this.state;
    let items = null;
    //培训证书字段
    if (type === 1 && personId) {
      items = [
        <Item label="获得途径" >
          {getFieldDecorator('channel', {
            initialValue: this.initialValue.channel,
            rules: [{ required: true, message: '请输入获得途径' }],
          })(<WizInput maxlength={50} placeholder='通过“机电3星实操认证”课程' />)}
        </Item>,
        <Item label="获得时间" required>
          {getFieldDecorator('certDate', {
            rules: [{ required: true, message: '请选择获得时间', }],
            initialValue: this.initialValue.certDate
          })(<WizDatePicker placeholder="请选择获得时间" />)}
        </Item>
      ];
    } else if (type === 2 && personId) { //电工证
      items = [
        <Item label="证书编码" >
          {getFieldDecorator('certCode', {
            initialValue: this.initialValue.certDetail ? this.initialValue.certDetail.certCode : undefined,
            rules: [{ required: true, message: '请输入证书编码' }],
          })(<WizInput maxlength={50} placeholder='请输入证书编码' />)}
        </Item>,
        <Item label="颁证单位" >
          {getFieldDecorator('awardUnit', {
            initialValue: this.initialValue.certDetail ? this.initialValue.certDetail.awardUnit : undefined,
            rules: [{ required: true, message: '请输入颁证单位' }],
          })(<WizInput maxlength={50} placeholder='请输入颁证单位' />)}
        </Item>,
        <Item label="有效期-开始日期" required>
          {getFieldDecorator('startDate', {
            rules: [{ required: true, message: '请选择日期', }],
            initialValue: this.initialValue.startDate
          })(<WizDatePicker placeholder="请选择开始日期" />)}
        </Item>,
        <Item label="有效期-结束日期" required>
          {getFieldDecorator('endDate', {
            rules: [{ required: true, message: '请选择日期', }],
            initialValue: this.initialValue.endDate
          })(<WizDatePicker placeholder="请选择结束日期" />)}
        </Item>,
        <Item label="复审日期" required>
          {getFieldDecorator('reCheckDate', {
            rules: [{ required: true, message: '请选择日期', }],
            initialValue: this.initialValue.reCheckDate
          })(<WizDatePicker placeholder="请选择复审日期" />)}
        </Item>,
        <Item label="初领日期" required>
          {getFieldDecorator('firstDate', {
            rules: [{ required: true, message: '请选择日期', }],
            initialValue: this.initialValue.firstDate
          })(<WizDatePicker placeholder="请选择初领日期" />)}
        </Item>,
        <Item label="证书照片(主)" >
          {getFieldDecorator('imgMain', {
            rules: [{ required: true, message: '请上传证书照片(主)', }],
            initialValue:
              (this.initialValue.certDetail && this.initialValue.certDetail.imgMain) ? [
                {fileId:this.initialValue.certDetail.imgMain}
              ] : []
          })(
            <WizAvatarUpload
              accept={'.jpg, .jpeg, .png'}
              listType={'picture-card'}
              aspectRatio={3 / 2}
              beforeUpload={(file) => {
                let result = true;
                const isLt1M = file.size / 1024 / 1024 < 2;
                if (file.type.indexOf('image/') == -1) {
                  Wizmessage.error('只能上传图片类型,请重新选择!');
                  result = false;
                } else if (!isLt1M) {
                  Wizmessage.error('图片不得超过2M!');
                  result = false;
                }
                return result;
              }}
            />
          )}
        </Item>,
        <Item label="证书照片（副）" >
          {getFieldDecorator('imgSecondary', {
            rules: [{ required: true, message: '请上传证书照片(副)', }],
            initialValue:
              (this.initialValue.certDetail && this.initialValue.certDetail.imgSecondary) ? [
                {fileId:this.initialValue.certDetail.imgSecondary}
              ] : []
          })(
            <WizAvatarUpload
              accept={'.jpg, .jpeg, .png'}
              listType={'picture-card'}
              aspectRatio={3 / 2}
              beforeUpload={(file) => {
                let result = true;
                const isLt1M = file.size / 1024 / 1024 < 2;
                if (file.type.indexOf('image/') == -1) {
                  Wizmessage.error('只能上传图片类型,请重新选择!');
                  result = false;
                } else if (!isLt1M) {
                  Wizmessage.error('图片不得超过2M!');
                  result = false;
                }
                return result;
              }}
            />
          )}
        </Item>
      ];
    }
    return items;
  }




  /**
   * 表单提交按钮
   */
  _submit() {
    const { type, certId, personId } = this.state;
    if (type && personId) {
      return (
        <Item wrapperCol={{ span: 12, offset: 6 }}>
          <WizRow>
            <WizCol span={24} style={{ textAlign: 'center' }}>
              <>
                <WizButton style={{ marginLeft: 20 }} title="保存" type="primary" htmlType="submit">保存</WizButton>
                <WizButton style={{ marginLeft: 20 }} onClick={this.handleReset}>重置</WizButton>
              </>
            </WizCol>
          </WizRow>
        </Item>
      )
    }
  }

  /**
   * 处理表单提交事件
   */
  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        if (this.props.onSubmit) {

          this.props.onSubmit(values);
        }
      }
    });
  };


  /**
   * 重置表单
   */
  handleReset = () => {
    this.props.form.resetFields();
    this.clearWizCallBack.forEach(callback => {
      callback && callback()
    })
    let certId = this.initialValue && this.initialValue.certId ? this.initialValue.certId : undefined;
    let personId = this.initialValue && this.initialValue.personId ? this.initialValue.personId : undefined;
    let type = this.initialValue && this.initialValue.certType ? this.initialValue.certType : undefined;
    let mobile = this.initialValue && this.initialValue.mobile ? this.initialValue.mobile : undefined;
    let idCard = this.initialValue && this.initialValue.idCard ? this.initialValue.idCard : undefined;
    let userName = this.initialValue && this.initialValue.userName ? this.initialValue.userName : undefined;
    let personState = this.initialValue && this.initialValue.userState ? this.initialValue.userState : undefined;
    this.setState({
      certId: certId,
      personId: personId,
      type: type,
      mobile: mobile,
      idCard: idCard,
      userName: userName,
      personState: personState
    })
  };

  _onClearWiz(callback) {
    if (callback) {
      this.clearWizCallBack.push(callback)
    }
  }

  _onClearWiz2(callback) {
    if (callback) {
      this.clearWizCallBack.push(callback)
      this.cleanCert = callback
    }
  }

  _onClearWiz3(callback) {
    if (callback) {
      this.clearWizCallBack.push(callback)
      this.cleanStudent = callback
    }
  }


  render() {
    const { getFieldDecorator } = this.props.form;
    const { title } = this.props;
    const formItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
    };

    return (
      <WizCard>
        <WizForm
          {...formItemLayout}
          onSubmit={this.handleSubmit}
        >
          {this._base()}
          {this._ext()}
          {this._baseEnd()}
          {this._submit()}
        </WizForm>
      </WizCard>
    )

  }
}

export default WizForm.create()(PersonalCertForm);
